



import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Tree from 'tui-tree';
import { GetProductsSearchForDisplayCategoryRequest } from 'supporter';
@Component({})
export default class Tuitree extends Vue {
  @Prop({required: true}) private nodedata!: object;
  @Prop({required: true}) private data!: [];
  @Prop({default: true}) private isDefaultSelected!: boolean;
  @Prop({default: false}) private onlySelectable!: boolean;
  @Prop({default: false}) private isChanged!: boolean;
  @Prop({default: false}) private isCheckedCategoryCode!: boolean;
  private tree: any;
  private hasEditNode: boolean = false;
  private noShowIcon: string = '<span class="ico_noshow"></span>';
  private theObjVal: string = '';
  private addMallProductNos: any = new Set();
  private removeMallProductNos: any = new Set();
  @Watch('data')
  onDataChanged() {
    this.tree.resetAllData(this.data);
    if (this.isDefaultSelected) {
      this.tree.select(this.tree.model.rootNode._childIds[0]);
    }
  }

  @Watch('nodedata')
  onnodeDataChanged() {
    this.setSelectedNodeData('displayCategoryName', this.nodedata, false);
    // this.tree.setNodeData(this.tree.getSelectedNodeId(), this.nodedata, false);
    // this.setSelectedNodeData('displayCategoryName', this.nodedata, false);
    // this.tree.resetAllData(this.data);
  }
  private addTree(): void {
    // let template = this.tree.add(obj, targetId);
    // if (targetId) {
    //   this.tree.open(template, true);
    // }
    // this.tree.select(template);

    const selectedNodeId = this.tree.getSelectedNodeId();
    const parentId = this.tree.getParentId(selectedNodeId);
    const displayYn = 'N';
    let addedNodeId = 0;

    this.tree.open(selectedNodeId);

    if (selectedNodeId) {
      const depth = this.tree.getDepth(selectedNodeId);
      let hasChild = false;

      if (depth == 5) {
        alert('최대 5단계까지 가능합니다.');

        return;
      }

      this.tree.eachAll((node: any) => {
        if (node._parentId == selectedNodeId) {
          hasChild = true;

          return true;
        }
      });
     
      addedNodeId = this.tree.add(
        {depth: hasChild ? depth + 1 : depth, text: '신규 카테고리', displayCategoryName: '신규 카테고리', displayYn, displayIcon: this.noShowIcon, isNew: true},
        hasChild ? selectedNodeId : parentId,
        {isSilent: depth == 5}
      );
    } else {
      addedNodeId = this.tree.add({depth: 1, text: '신규 카테고리', displayCategoryName: '신규 카테고리', displayYn, displayIcon: this.noShowIcon, isNew: true});
    }

    $('#config_table, #saveBtnWrap, .arcodion_item, #configDesc').show();
    // $('#config_info, #defaultTreeText').hide();

    // 기획상 부모가 다른 node들은 close 해줌
    const parentsId: [] = [];
    this.getParentsId(parentsId, addedNodeId);
    this.tree.eachAll((node: any, nodeId: never) => {
      if (!parentsId.includes(nodeId)) {
        this.tree.close(nodeId);
      }
    });

    this.tree.select(addedNodeId);
    this.tree.editNode(addedNodeId);
    this.hasEditNode = true;
  }
  private setSelectedNodeData(index: any, value: any, toAdd: any) {
    const selectedNodeId = this.tree.getSelectedNodeId();
    if (selectedNodeId) {
      const data = this.tree.getNodeData(selectedNodeId);
      if (data) {
        data[index] = toAdd ? data[index] + value : value;
        this.tree.setNodeData(selectedNodeId, data);
      }
    }
  }
  private getParentsId(parentsId: any, nodeId: any) {
    const parentId = this.tree.getParentId(nodeId);
    if (parentId) {
      parentsId.push(parentId);
      this.getParentsId(parentsId, parentId);
    }
  }
  private getParentsName(parentsNameArr: any, nodeId: any) {
    const parentId = this.tree.getParentId(nodeId);
    const parentName = parentId && this.tree.getNodeData(parentId).text;
    if (!parentName) {
      return this.tree.getNodeData(nodeId).text;
    }
    if (parentId) {
      parentsNameArr.unshift(parentName);
      this.getParentsName(parentsNameArr, parentId);
    }
    return parentsNameArr;
  }
  private onKeyupCategoryName(e: any) {
    const value = $(e.target).val();
    const editNodeId = this.tree.getSelectedNodeId();
    const displayCategoryNo = this.tree.getNodeData(editNodeId).displayCategoryNo;
    let tempArray: any = undefined;
    if (displayCategoryNo) {
      tempArray = this.data.filter(function(elem: any){
        return elem.displayCategoryNo === displayCategoryNo;
      });
    }

    const beforeValue = (tempArray && tempArray[0] && tempArray[0].displayCategoryName) ? tempArray[0].displayCategoryName : '';
    const response = this.categoryNameValidation(value, beforeValue);

    if (response.isValid) {
      const tree = this.tree;
      const selectedNodeId = tree.getSelectedNodeId();
      if (selectedNodeId) {
        tree.editNode(selectedNodeId);
        if (value) {
          $('.tui-tree-input')
            .val(value)
            .trigger('blur');
        }
      }
    } else {
      $(e.target).val(response.nodeValue);
      $(e.target).focus();
      this.$emit('updateStrLen', response.nodeValue);
    }
  }
  private categoryNameValidation(nodeValue: any, beforeValue: any) {
    const regx = /<(\/)?([a-zA-Z]*)(\/)?>/gi;
    let isValid = false;

    if (!nodeValue) {
      alert('카테고리명을 정확히 입력해주세요.');
      nodeValue = beforeValue;
    } else if (regx.test(nodeValue)) {
      alert('html 태그는 입력할 수 없습니다.');
      nodeValue = nodeValue.replace(regx, '');
    } else {
      isValid = true;
    }

    return {isValid: isValid, nodeValue: nodeValue};
  }
  private setNodeDisplayYn(nodeId: any, parentId: any) {
    const nodeData = this.tree.getNodeData(nodeId);
    const isHide = this.tree.getNodeData(parentId).displayYn == 'N';
    nodeData.displayYn = isHide ? 'N' : nodeData.displayYn || 'Y';
    nodeData.displayIcon = nodeData.displayYn == 'N' ? this.noShowIcon : '';
    this.tree.setNodeData(nodeId, nodeData);
    this.tree.select(nodeId);
    this.tree.open(nodeId, true);
  }
  private beforeMoveFun(evt: any) {
    const tree = this.tree;
    const parentId = evt.newParentId;
    const parentData = tree.getNodeData(parentId);
    const parentNo = parentData ? parseInt(parentData.displayCategoryNo) : 0;
    const parentDepth = parentData ? parseInt(parentData.depth) : 0;
    const childIds = tree.getChildIds(evt.nodeId);

    if (parentDepth > 4 || (parentDepth > 3 && childIds.length > 0)) {
        alert('최대 5단계까지 가능합니다.');
        return false;
    }

    if (childIds.length > 0) {
        const checkNodeDepth = this.checkNodeDepth(parentDepth, evt.nodeId);
        if (!checkNodeDepth) {
            alert('최대 5단계까지 가능합니다.');
            return false;
        }
    }

    const result = this.changeNodeDepth(parentNo, parentDepth, evt.nodeId);
    if (result) {
        this.hasEditNode = true;
    }

    return result;
  }

  private checkNodeDepth(parentDepth: any, nodeId: any) {
    let result = true;
    const _this = this;
    const tree = _this.tree;
    const childIds = tree.getChildIds(nodeId);
    let checkChild3Depth = 0;
    let checkChild4Depth = 0;
    let checkChild5Depth = 0;

    childIds.forEach(childId => {
        const depth3ChildIds = tree.getChildIds(childId);
        if (depth3ChildIds.length > 0) {
            checkChild3Depth = 3;
            depth3ChildIds.forEach(childId => {
                const depth4ChildIds = tree.getChildIds(childId);
                if (depth4ChildIds.length > 0) {
                    checkChild4Depth = 4;
                    depth4ChildIds.forEach(childId => {
                        const depth5ChildIds = tree.getChildIds(childId);
                        if (depth5ChildIds.length > 0) {
                            checkChild5Depth = 5;
                        }
                    });
                }
            });
        }
    });

    switch (parentDepth) {
      case 3 :
          if (checkChild3Depth !== 0) {
              result = false;
          }
          break;
      case 2 :
          if (checkChild4Depth !== 0) {
              result = false;
          }
          break;
      case 1 :
          if (checkChild5Depth !== 0) {
              result = false;
          }
          break;
    }

    return result;
  }

  private changeNodeDepth(parentNo: any, parentDepth: any, nodeId: any) {
    if (parentDepth > 4) {
        alert('최대 5단계까지 가능합니다.');
          return false;
    }

    const _this = this;
    const tree = _this.tree;
    const nodeData = tree.getNodeData(nodeId);
    const childIds = tree.getChildIds(nodeId);
    let result = true;

    nodeData.depth = parentDepth + 1;
    nodeData.parentDisplayCategoryNo = parentNo;

    if (childIds) {
      childIds.forEach(chlidId => {
          result = _this.changeNodeDepth(parseInt(nodeData.displayCategoryNo), nodeData.depth, chlidId);
          if (!result) {
            return false;
          }
        });
    }

     tree.setNodeData(nodeId, nodeData);

    return result;
  }

  private onChangeDisplayYn() {
    const selectedNodeId = this.tree.getSelectedNodeId();
    const childIds = this.tree.getChildIds(selectedNodeId);
    const displayYn = $('.displayYn:checked').val();

    if (displayYn == 'N' && childIds && childIds.length > 0) {
      if (confirm('하위 카테고리가 모두 전시안함으로 설정됩니다. 저장 하시겠습니까?')) {
        this.setChildDisplayYnData(childIds);
      } else {
        $('.displayYn[value=Y]').prop('checked', true);

        return false;
      }
    }

    this.setDisplayYnData(selectedNodeId);
  }
  private setChildDisplayYnData(nodeIds: any) {
    if (!nodeIds || nodeIds.length == 0) {
      return false;
    }

    nodeIds.forEach((id: any) => {
      const childIds = this.tree.getChildIds(id);
      this.setDisplayYnData(id);
      this.setChildDisplayYnData(childIds);
    });
  }
  private setDisplayYnData(nodeId: any) {
    const data = this.tree.getNodeData(nodeId);
    const displayYn = $('.displayYn:checked').val();

    data.displayYn = displayYn;
    data.displayIcon = displayYn == 'Y' ? '' : this.noShowIcon;
    this.hasEditNode = true;
    this.tree.setNodeData(nodeId, data);
  }
  private setConfigTable(nodeId: any) {
    const tree = this.tree;
    const data = tree.getNodeData(nodeId);
    const parentId = tree.getParentId(nodeId);

    if (!data.displayCategoryNo) {
      $('#displayCategoryNo').text('카테고리 저장시 번호가 할당 됩니다. ');
      $('#displayCategoryUrl').text('카테고리 저장시 URL이 변경 됩니다. ');
    } else {
      $('#displayCategoryUrl').text(`mock url  ${data.displayCategoryNo}`);
      $('#displayCategoryNo').text(data.displayCategoryNo);
    }

    $(`input:radio[name="topImageUseYn"]:input[value="${data.topImageContent ? 'Y' : 'N'}"]`).prop('checked', true);
    $(`input:radio[name="displayYn"]:input[value="${data.displayYn}"]`).prop('checked', true);
    //
    const parentData = tree.getNodeData(parentId);
    if (parentData) {
      $('.displayYn').prop('disabled', parentData.displayYn == 'N');
    }
  }
  private checkEditProducts() {
    if (this.addMallProductNos.size || this.removeMallProductNos.size) {
      if (confirm('저장되지 않은 내용이 있습니다. 화면을 이동하시겠습니까?')) {
        this.addMallProductNos = new Set();
        this.removeMallProductNos = new Set();

        return true;
      }

      return false;
    }

    return true;
  }
  private mounted() {
    this.tree = new Tree('#tree', {
      data: this.data,
      nodeDefaultState: 'opened',
      template: {
        internalNode: `<div class="tui-tree-content-wrapper">
                                                  <button type="button" class="tui-tree-toggle-btn tui-js-tree-toggle-btn">
                                                    <span class="tui-ico-tree"></span>
                                                  </button>
                                                  <span class="tui-tree-text tui-js-tree-text">
                                                    <span class="tui-tree-ico tui-ico-folder"></span>
                                                    {{text}}{{displayIcon}}
                                                  </span>
                                                </div><ul class="tui-tree-subtree tui-js-tree-subtree">{{children}}</ul>`,
        leafNode: `<div class="tui-tree-content-wrapper" style="padding-left: {{indent}}px">
                                                <span class="tui-tree-text tui-js-tree-text">
                                                    <span class="tui-tree-ico tui-ico-file"></span>
                                                    {{text}}{{displayIcon}}
                                                </span>
                                            </div>`
      }
    }).enableFeature('Selectable', {
      selectedClassName: 'tui-tree-selected'
    });
    if (!this.onlySelectable) {
      this.tree
        .enableFeature('Editable', {
          dataKey: 'text'
        })
        .on('beforeEditNode', (evt: any) => {
          let nodeValue = evt.value;
          this.theObjVal = nodeValue;
          const regx = /<(\/)?([a-zA-Z]*)(\/)?>/gi;

          if (!nodeValue) {
            alert('카테고리명을 정확히 입력해주세요.');
            const beforeValue = this.tree.getNodeData(evt.nodeId).displayCategoryName;
            $('.tui-tree-input')
              .val(beforeValue || '')
              .focus();
            this.setSelectedNodeData('displayCategoryName', beforeValue, false);
            this.$emit('updateStrLen', beforeValue);
            return false;
          } else if (regx.test(nodeValue)) {
            alert('html 태그는 입력할 수 없습니다.');
            nodeValue = nodeValue.replace(regx, '');
            $('.tui-tree-input')
              .val(nodeValue)
              .focus();
            this.setSelectedNodeData('displayCategoryName', nodeValue, false);
            this.$emit('updateStrLen', nodeValue);
            return false;
          }
          this.hasEditNode = true;
          this.setSelectedNodeData('displayCategoryName', nodeValue, false);
          var nodeData = this.tree.getNodeData(evt.nodeId);
          const depth = this.tree.getDepth(evt.nodeId);
          const parentId = this.tree.getParentId(evt.nodeId);
          const parentData = this.tree.getNodeData(parentId);
          this.$emit('changeSelect', {theObj: nodeData, theIndex: depth, theParentData: parentData});
          return true;
        });
      this.tree.enableFeature('Draggable', {
        helperClassName: 'tui-tree-drop',
        lineClassName: 'tui-tree-line',
        isSortable: true
      }).on('beforeMove', (evt:any) =>{
        const newParentNode = this.tree.getNodeData(evt.newParentId);
        
        if (!newParentNode.displayCategoryNo) {
          return;
        }

        const nodeId = evt.nodeId;
        const parentId = this.tree.getParentId(evt.nodeId);
        const index = this.tree.getNodeIndex(evt.nodeId);

        const obj: GetProductsSearchForDisplayCategoryRequest = {
          params: {
            mallNo: newParentNode.mallNo,
            displayCategoryNo: newParentNode.displayCategoryNo,
            page: 1,
            size: 1
          }
        };

        this.$api.getProductsSearchForDisplayCategory(obj).then(({data}: any) => {
          if (data && data.totalCount > 0) {
            alert('해당 카테고리에 등록된 상품이 있어, 하위 카테고리를 추가할 수 없습니다.');
            this.tree.move(nodeId, parentId, index);
            return false;
          }

          if (evt.newParentId == 'tui-tree-node-0') {
            this.setNodeDisplayYn(nodeId, evt.newParentId);
            return true;
          }

          if (this.beforeMoveFun(evt)) {
            this.setNodeDisplayYn(nodeId, evt.newParentId);
            return true;
          }
          return false;
        });
      });
    }
    this.tree.on('beforeSelect', () => {
      if (!this.isCheckedCategoryCode) {
        alert('카테고리 코드 중복확인을 진행해주세요.');
        return false;
      }

      if (this.isChanged) {
        if (!confirm('저장되지 않은 내용이 있습니다. 화면을 이동하시겠습니까?')) {
          return false;
        } else {
          return true;
        }
      }
    });
    this.tree.on('select', (eventData: any) => {
      const nodeId = eventData.nodeId;
      this.setConfigTable(nodeId);
      this.tree.open(nodeId);
      var nodeData = this.tree.getNodeData(eventData.nodeId);
      const depth = this.tree.getDepth(eventData.nodeId);
      const parentId = this.tree.getParentId(eventData.nodeId);
      const parentData = this.tree.getNodeData(parentId);
      this.$emit('changeSelect', {theObj: nodeData, theIndex: depth, theParentData: parentData, curId: eventData.nodeId});
    });
  }
}
